import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: false,
    showCurrentCapitalValue: true,
    claims: claimsConfig.RS,
    dashboard: dashboardConfig.RS,
    funds: fundsConfig.RS,
    modifications: modificationsConfig.RS,
    servicing: servicingConfig.RS,
};
